import { Component, EventEmitter, OnChanges } from '@angular/core';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerLookupService } from '../customer-lookups.service';
import { CustomerCharacteristic } from '../models/customer-characteristic.model';
import { CustomerManageService } from '../shared/customer-manage.service';
import { CharacteristicContext, CustomerCharacteristicModalComponent } from './customer-characteristic-modal.component';
import { HistoricalCharacteristicContext, HistoricalCustomerCharacteristicModalComponent } from './historical-customer-characteristic-modal.component';
import { AccessControlType } from '../../foundation/models/enums/access-control-type.enum';
import { CustomerCharacteristicType } from '../models/enums/customer-characteristic-type.enum';

@Component({
    selector: 'customer-characteristic',
    templateUrl: './customer-characteristic.html',
    inputs: ['customerNumber', 'characteristics', 'canEdit', 'canRemove', 'deceased', 'canEditRedactedRecord'],
    outputs: ['acpChanged', 'onCharacteristicChange']
})

export class CustomerCharacteristicComponent extends BaseComponent implements OnChanges {
    public characteristics: CustomerCharacteristic[];
    public customerNumber: number;
    public isSexOffender = false;
    public canEdit: boolean;
    public canRemove: boolean;
    public deceased = false;
    public canEditRedactedRecord = false;
    public acpChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    public onCharacteristicChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    private characteristicTypes: any[];
    private accessControlType: AccessControlType = new AccessControlType();
    private canEditBlueEnvelopeCharacteristics = false;
    private customerCharacteristicType: CustomerCharacteristicType = new CustomerCharacteristicType();

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService,
        private lookupService: CustomerLookupService) {
        super();
    }

    ngOnInit() {
        this.canEditBlueEnvelopeCharacteristics = this.auth.hasACSTransactionClaimEx(this.auth.acsTransactionClaim, this.accessControlType.BlueEnvelopeEdit.value);

        this.customerService.getCustomerType(this.customerNumber).subscribe(customerType => {
            let customerTypeText = customerType == 1 ? 'individual' : 'organization';
            this.lookupService.getData(customerTypeText).subscribe(lookups => {
                this.characteristicTypes = lookups.result.customerCharacteristicTypes;
                if (this.characteristics !== undefined) {
                    this.denormalizeData();
                } else if (this.customerNumber != null) {
                    this.populateCharacteristics(this.customerNumber);
                }
            });
        });
    }

    ngOnChanges() {
        if (this.characteristics !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateCharacteristics(this.customerNumber);
        }
    }

    populateCharacteristics(customerNumberId: number) {
        var self = this;

        this.customerService.getCustomerCharacteristics(customerNumberId)
            .subscribe(result => {
                this.characteristics = result;

            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();

                this.sexOffenderCheck();
            });
    }

    /**
     * Check to see if the current user has the sex offender characteristic.
     */
    public sexOffenderCheck() {
        // Sex offender check
        let filteredTypes: any[];
        filteredTypes = this.characteristicTypes ? this.characteristicTypes.filter(type => type.text == 'Sex Offender') : [];
        let sexOffenderId = filteredTypes.length == 1 ? filteredTypes[0].value : 0;
        this.isSexOffender = false;
        this.characteristics.forEach(c => {
            if (c.customerCharacteristicTypeId == sexOffenderId) {
                this.isSexOffender = true;
            }
        });
    }

    denormalizeData() {
        for (const characteristic of this.characteristics) {
            characteristic.characteristicType = this.getValues(characteristic.customerCharacteristicTypeId, this.characteristicTypes);
        }
    }

    getValues(id: number, types: any[]): string {
        if (id !== undefined && id !== null && types !== undefined && types !== null) {
            let rType = types.filter(type => type.value == id);
            if (rType.length == 1) {
                return rType[0].text;
            }
        }
        return '';
    }

    addCharacteristic() {

        this.sexOffenderCheck();

        const data = new CharacteristicContext(0, this.customerNumber, this.isSexOffender, this.deceased, this.canEditRedactedRecord);
        this.modalService.open(CustomerCharacteristicModalComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                result => {
                    this.onCharacteristicChange.emit(true);

                    if (result != undefined && result.acpChanged) {
                        this.acpChanged.emit(result.isACP);
                    }
                }
            );
    }

    editCharacteristic(id) {

        this.sexOffenderCheck();

        const data = new CharacteristicContext(id, this.customerNumber, this.isSexOffender, this.deceased, this.canEditRedactedRecord,  this.canRemove);
        this.modalService.open(CustomerCharacteristicModalComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                result => {
                    this.onCharacteristicChange.emit(true);

                    if (result != undefined && result.acpChanged) {
                        this.acpChanged.emit(result.isACP);
                    }
                }
            );
    }

    showHistory(id) {
        const data = new HistoricalCharacteristicContext(id, this.customerNumber);
        this.modalService.open(HistoricalCustomerCharacteristicModalComponent, data);
    }

    // Methods that shows or hides the edit option for accommodations characteristics based on the ACSTransactionType
    accommodationEditClearance(rowData) {
        if (rowData.customerCharacteristicTypeId == this.customerCharacteristicType.CommunicationAccommodationVehicle.id
            || rowData.customerCharacteristicTypeId == this.customerCharacteristicType.CommunicationAccommodationCustomer.id) {
            return this.canEditBlueEnvelopeCharacteristics;
        }

        return true;
    }
}
